import React from 'react';
import { ArrowUpRight } from 'lucide-react';

const projects = [
    {
        title: "Aira Health",
        category: "iOS & Android",
        image: "https://images.unsplash.com/photo-1616423640778-28d1b53229bd?q=80&w=1974&auto=format&fit=crop",
        desc: "A precision medicine tracking application built entirely in Flutter."
    },
    {
        title: "Nexus Finance",
        category: "Web & Mobile App",
        image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?q=80&w=2070&auto=format&fit=crop",
        desc: "Cross-platform banking dashboard with 60fps charting animations."
    }
];

export default function Portfolio() {
    return (
        <section className="py-32 px-6 md:px-16 bg-white shrink-0" id="portfolio">
            <div className="max-w-6xl mx-auto">
                <div className="flex flex-col md:flex-row md:items-end justify-between mb-16 gap-8">
                    <div className="max-w-xl">
                        <h2 className="font-heading text-4xl md:text-5xl font-bold mb-4 tracking-tight text-primary">Deployed <span className="text-drama text-accent">Systems</span></h2>
                        <p className="text-dark/70 font-subheading text-lg">
                            A selection of cross-platform architectures we've engineered for our partners. Built once. Deployed everywhere.
                        </p>
                    </div>
                    <button className="magnetic-btn w-fit border border-dark/20 text-dark px-6 py-3 rounded-full font-heading font-medium hover:bg-dark hover:text-background transition-colors flex items-center gap-2">
                        View full archive <ArrowUpRight size={16} />
                    </button>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12">
                    {projects.map((project, idx) => (
                        <div key={idx} className="group cursor-pointer">
                            <div className="w-full aspect-[4/3] rounded-[2rem] overflow-hidden mb-6 relative bg-dark/5">
                                <img
                                    src={project.image}
                                    alt={project.title}
                                    className="w-full h-full object-cover transition-transform duration-700 ease-[cubic-bezier(0.25,0.46,0.45,0.94)] group-hover:scale-105"
                                />
                                <div className="absolute inset-0 bg-dark/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                                    <div className="w-16 h-16 bg-background rounded-full flex items-center justify-center translate-y-4 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-500 delay-100">
                                        <ArrowUpRight className="text-primary" />
                                    </div>
                                </div>
                            </div>
                            <div className="flex items-center justify-between mb-2">
                                <h3 className="font-heading text-2xl font-bold text-primary">{project.title}</h3>
                                <span className="font-data text-xs px-3 py-1 bg-dark/5 rounded-full text-dark/70 uppercase tracking-widest">{project.category}</span>
                            </div>
                            <p className="font-subheading text-dark/60">{project.desc}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
